import { Box, Button, Card, Typography, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import LockIcon from "@mui/icons-material/Lock";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { palette } = useTheme();

  const styles = {
    box: {
      height: "100vh",
      maxWidth: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: palette.primary.light,
    },
    card: {
      width: "500px",
      height: "500px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-evenly",
      p: 2,
      textAlign: "center",
    },
  };

  return (
    <Box sx={styles.box}>
      <Card sx={styles.card}>
        <LockIcon fontSize="large" />
        <Typography variant="h2">
          401
        </Typography>
        <Typography variant="h5">
          Você não tem autorização para acessar essa página.
        </Typography>
        <Button
          sx={{ p: 1, width: "40%", mt: 4 }}
          color="primary"
          variant="contained"
          onClick={() => navigate("/")}
          startIcon={<KeyboardReturnIcon />}
        >
          Voltar
        </Button>
      </Card>
    </Box>
  );
};

export default Unauthorized;
